
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComCallEndGoogle as ObiComCallEndGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-call-end-google.js';
 
 
 

 
 export const ObiComCallEndGoogle = createComponent({
   react: React,
   tagName: 'obi-com-call-end-google',
   elementClass: ObiComCallEndGoogleElement,
   events: {
     
   }
  });
 
 